import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["labelStack"],
  _excluded2 = ["labelStack"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig } from '../../../config';
import { getReactUFOPayloadVersion } from '../../utils/get-react-ufo-payload-version';
export function sanitizeUfoName(name) {
  return name.replace(/_/g, '-');
}
export function isSegmentLabel(obj) {
  return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
export function buildSegmentTree(labelStacks) {
  var r = {
    n: 'segment-tree-root',
    c: {}
  };
  var config = getConfig();
  var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
  var addSegmentsMap = new Map();
  if (fg('platform_ufo_add_segments_count_threshold')) {
    labelStacks.forEach(function (labelStack) {
      var stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
      var currentNode = r;
      var _iterator = _createForOfIteratorHelper(labelStack),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var label = _step.value;
          var isSegment = isSegmentLabel(label);
          var name = label.name;
          if (isSegment && segmentThreshold && segmentThreshold[name]) {
            var threshold = segmentThreshold[name];
            var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
            if (count < threshold) {
              addSegmentsMap.set(stringifiedLabelStack, count + 1);
            } else {
              break;
            }
          }
          var id = isSegment ? label.segmentId : undefined;
          var key = id !== undefined ? id : name;
          var type = isSegment ? label.type : undefined;
          if (!currentNode.c) {
            currentNode.c = {};
          }
          if (!currentNode.c[key]) {
            currentNode.c[key] = _objectSpread({
              n: name
            }, type ? {
              t: type
            } : {});
          }
          currentNode = currentNode.c[key];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  } else {
    labelStacks.forEach(function (labelStack) {
      var currentNode = r;
      labelStack.forEach(function (label) {
        var name = label.name;
        var id = isSegmentLabel(label) ? label.segmentId : undefined;
        var key = id !== undefined ? id : name;
        var type = isSegmentLabel(label) ? label.type : undefined;
        if (!currentNode.c) {
          currentNode.c = {};
        }
        if (!currentNode.c[key]) {
          currentNode.c[key] = _objectSpread({
            n: name
          }, type ? {
            t: type
          } : {});
        }
        currentNode = currentNode.c[key];
      });
    });
  }
  return {
    r: r
  };
}
export function stringifyLabelStackFully(labelStack) {
  return labelStack.map(function (l) {
    if (isSegmentLabel(l)) {
      return "".concat(l.name, ":").concat(l.segmentId);
    }
    return l.name;
  }).join('/');
}
export function stringifyLabelStackWithoutId(labelStack) {
  return labelStack.map(function (l) {
    if (isSegmentLabel(l)) {
      return "".concat(l.name, ":segment");
    }
    return l.name;
  }).join('/');
}
function getLabelStackReference(labelStack) {
  return labelStack.map(function (l) {
    return isSegmentLabel(l) ? l.segmentId : l.name;
  }).join('/');
}
export function labelStackStartWith(labelStack, startWith) {
  return stringifyLabelStackFully(labelStack).startsWith(stringifyLabelStackFully(startWith));
}
export function optimizeLabelStack(labelStack, reactUFOVersion) {
  return reactUFOVersion === '2.0.0' ? getLabelStackReference(labelStack) : labelStack.map(function (ls) {
    return _objectSpread(_objectSpread({
      n: ls.name
    }, ls.segmentId ? {
      s: ls.segmentId
    } : {}), ls.type ? {
      t: ls.type
    } : {});
  });
}
export function getOldSegmentsLabelStack(segments, interactionType) {
  if (fg('platform_ufo_add_segments_count_threshold')) {
    var config = getConfig();
    var addSegmentsMap = new Map();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(function (_ref) {
      var labelStack = _ref.labelStack,
        others = _objectWithoutProperties(_ref, _excluded);
      var stringifiedLabelStack = stringifyLabelStackWithoutId(labelStack);
      var segmentsInfo = [];
      var _iterator2 = _createForOfIteratorHelper(labelStack),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ls = _step2.value;
          var isSegment = isSegmentLabel(ls);
          if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
            var threshold = segmentThreshold[ls.name];
            var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
            if (count < threshold) {
              addSegmentsMap.set(stringifiedLabelStack, count + 1);
            } else {
              break;
            }
          }
          segmentsInfo.push(_objectSpread(_objectSpread({
            n: ls.name
          }, ls.segmentId ? {
            s: ls.segmentId
          } : {}), ls.type ? {
            t: ls.type
          } : {}));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return _objectSpread(_objectSpread({}, others), {}, {
        labelStack: segmentsInfo
      });
    });
  }
  return segments.map(function (_ref2) {
    var labelStack = _ref2.labelStack,
      others = _objectWithoutProperties(_ref2, _excluded2);
    return _objectSpread(_objectSpread({}, others), {}, {
      labelStack: optimizeLabelStack(labelStack, getReactUFOPayloadVersion(interactionType))
    });
  });
}